export const globals = {
  Services: null,
  Router: null,
  Store: null,
  RouteNames: null,
  RouteDefs: null,
  ModuleMaps: null,
};

export default globals;